import backJulietDerchi from "@/src/assets/admissionOfficePage/back-for-student-letter-swiss-juliet-derchi.webp";
import backInesaMikhno from "@/src/assets/admissionOfficePage/back-for-student-letter-swiss-inesa-mikhno.webp";
import backSugumaran from "@/src/assets/admissionOfficePage/back-for-student-letter-swiss-the-director-santhosh-sugumaran.webp";
import backSugumaranSignature from "@/src/assets/admissionOfficePage/back-for-student-letter-swiss-the-director-santhosh-sugumaran-signature.webp";

export const SWITZERLAND_STUDENT_LETTER_BACKGROUNDS: Record<string, string> = {
  "Juliet Derchi": backJulietDerchi,
  "Inesa Mikhno": backInesaMikhno,
  "The Director Santhosh Sugumaran": backSugumaran,
  "The Director Santhosh Sugumaran + signature": backSugumaranSignature,
};

export const getSwitzerlandStudentLetterBackground = (signature?: string | null): string => {
  if (signature && SWITZERLAND_STUDENT_LETTER_BACKGROUNDS[signature]) {
    return SWITZERLAND_STUDENT_LETTER_BACKGROUNDS[signature];
  }
  return backJulietDerchi;
};
